// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"code-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.5001 14.5006L21.9998 11.9996L18.4643 8.4641M6.99981 7.00043L2 12.0002L5.53553 15.5358","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 4.00049L20 20.0005","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CodeOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'code-off',
    ref,
    icon: element,
  },
));

CodeOffIcon.displayName = 'CodeOffIcon';

export default CodeOffIcon;
